// May this Auftragnehmer issue a Rechnung to this Auftraggeber (spec §1.10 step 1)?
//
// Computed at submit, never stored, and reused by the Profil screen to mark "fehlt". It lives in
// src/shared so the future client shows the same list of missing fields the server refuses on, and it takes
// plain values rather than a database row so neither side has to know about `address_json`.
import type { VatMode } from './profil'

/**
 * The 27 EU member states. A reverse-charge issuer established inside the EU must print his own USt-IdNr.
 * next to the recipient's (§ 14a Abs. 1/5 UStG); an issuer outside it has none and prints only the
 * recipient's (spec §1.10 step 1, D2 — BestLife Agency LLC).
 */
export const EU_COUNTRIES: readonly string[] = [
  'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE',
  'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK',
]

export interface ProfileAddress {
  street?: string | null
  zip?: string | null
  city?: string | null
  country?: string | null
}

export interface ProfileContractor {
  legal_name: string | null
  address: ProfileAddress | null
  country: string
  vat_mode: VatMode
  vat_id: string | null
  tax_number: string | null
  iban: string | null
  account_holder: string | null
}

export interface ProfileTenant {
  vat_id: string | null
}

export interface ProfileCompleteness {
  complete: boolean
  /** German field labels, in the order the Profil screen shows them */
  fehlt: string[]
}

function blank(value: string | null | undefined): boolean {
  return value === null || value === undefined || value.trim() === ''
}

export function contractorProfileComplete(c: ProfileContractor, t: ProfileTenant): ProfileCompleteness {
  const fehlt: string[] = []
  if (blank(c.legal_name)) fehlt.push('Rechtlicher Name')
  const a = c.address
  if (a === null || a === undefined || blank(a.street) || blank(a.zip) || blank(a.city) || blank(a.country)) {
    fehlt.push('Anschrift')
  }
  if (blank(c.iban)) fehlt.push('IBAN')
  if (blank(c.account_holder)) fehlt.push('Kontoinhaber')

  if (c.vat_mode === 'reverse_charge') {
    // § 13b: the document names the recipient's USt-IdNr. always, the issuer's only when he is in the EU.
    if (EU_COUNTRIES.includes(c.country) && blank(c.vat_id)) fehlt.push('USt-IdNr. des Auftragnehmers')
    if (blank(t.vat_id)) fehlt.push('USt-IdNr. des Auftraggebers')
  } else if (blank(c.tax_number) && blank(c.vat_id)) {
    fehlt.push('Steuernummer oder USt-IdNr.')
  }

  return { complete: fehlt.length === 0, fehlt }
}
